import { Colors, FontWeight } from '../../../assets/styles';
import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme)  => {
  const pxToRem = (px: number): string => `${px / 16}rem`;

  return {
    container: {
      display: 'flex',
      flexDirection: 'column',
    },
    header: {
      display: 'flex',
      justifyContent: 'space-between',
    },
    label: {
      color: Colors.Blue,
      fontWeight: FontWeight.Bold,
    },
    labelError: {
      color: Colors.Red,
    },
    inputWrapper: {
      marginTop: '12px !important',
      border: `1px solid ${Colors.Gray2}`,
      backgroundColor: Colors.White,
      borderRadius: 1,
      height: 40,
    },
    inputWrapperNoLabel: {
      marginTop: '0 !important',
    },
    startAdornment: {
      paddingLeft: '17px',
      '& .MuiInputBase-input': {
        paddingLeft: 0,
      },
    },
    endAdornment: {
      paddingRight: '17px',
      '& .MuiInputBase-input': {
        paddingRight: '0px !important',
      },
    },
    textareaInput: {
      height: '100%',
      '& .MuiInputBase-input': {
        pt: '10px',
        pb: '10px',
      },
    },
    inputError: {
      borderColor: Colors.Red,
    },
    input: {
      padding: '0 17px 0 17px !important',
      height: '100%',
      '&::placeholder': {
        color: Colors.Gray,
      },
    },
    passwordToggle: {
      fontSize: pxToRem(15),
      fontWeight: FontWeight.Light,
      color: Colors.Blue1,
    },
    error: {
      fontWeight: FontWeight.Regular,
      fontSize: 14,
    },
    maxLength: {
      marginTop: '10px',
    },
  };
});

export default useStyles;
